export const VENDOR_LIST = "LOTTERY_VENDOR_LIST";
export const GAME_LIST = "LOTTERY_GAME_LIST";
export const LOTTERY_GAME_ACCESS = "LOTTERY_GAME_ACCESS";